module.exports = __webpack_public_path__ + "img/squash.8bfa9e1e.svg";